<div id="browse-file-wizard">
    <upload [uploadDescription]="uploadDescription"></upload>
</div>
